import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import { API_URL,isEmpty } from '../../config'
import $ from 'jquery'
import Forgot from './ForgotPassword'

class login extends Component {

    constructor() {
        super();
        this.state = {

            emailID: "",
            pwd: "",
            loginIP: "",
            loginBrowser: "",
            deviceType: "",
            userLocation: "",
            logIsp: "",
            ii: 0,
            actions: [],
            pLogo: ""
        }




    }
   
     componentDidMount(){  
          console.clear() 
       
        const publicIp = require('public-ip');

        (async () => {
            this.setState({loginIP:await publicIp.v4()});
           // alert(await publicIp.v4());
            //=> '46.5.21.123'
        
           // alert(await publicIp.v6());
            //=> 'fe80::200:f8ff:fe21:67cf'
        })();

       
        console.log = function () {};
       
 
        // if(localStorage.length>=1 && (localStorage.getItem("token")!="" || localStorage.getItem("token")!=undefined )){
        //    window.location.href = "/Dashboard";
        // }
    }
    submit() {
        let pwd = document.getElementById("login-password").value
        let email = document.getElementById("login-id").value
        
        if (email == '' || pwd == '') {
            swal({
                title: "OOPS!",
                text: "Please enter your username and password!",
                icon: "warning",
            });

            return;
        }
        //////////////////////////////
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
               // "email": email,
               // "password": pwd,
                "username":email,
                 "password":pwd,
                 "loginip":this.state.loginIP

            })
        };

$(".loading").removeClass("d-none")
//alert()
        let logourl = API_URL + "/authenticate";
        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {
                $(".loading").addClass("d-none")
                console.log(json.token) 
                if(json.token!=""){
                    this.getdist(json)
              
                }
                else {
                    swal({
                        title: "OOPS!",
                        text: "Please enter correct username and password!",
                        icon: "warning",
                    });
                }
                 
            })
            .catch( (e) => {

                $(".loading").addClass("d-none")

                Swal.fire({
                    title: "OOPS!..",
                    text: "Please enter correct username and password!",          
                    icon: "warning",
                });
    
                console.log(e)
            })
        //////////////////////////////
 

    }
getdist(json) {

    const content = document.createElement('div');
        const input = document.createElement('img');
        input.src = 'https://miro.medium.com/max/875/1*CsJ05WEGfunYMLGfsT2sXA.gif';
        input.width="250"
        content.appendChild(input);
        
                            swal({
                               
                                text: "Please wait",
                              
                                allowOutsideClick: false,
                                buttons:false,
                                content
                            });

    localStorage.setItem("token", "Bearer " + json.token)
   
   localStorage.setItem("emailId", json.user.emailId)
   localStorage.setItem("customerCode", '0');
   
   if(json.userType.toLowerCase()==="distributor")
   {
   localStorage.setItem("phoneNo", json.user.phoneNo1);
   localStorage.setItem("empCode", json.user.customerCode) ;
   localStorage.setItem("empName", json.user.customerName);
   localStorage.setItem("customerCode", json.user.customerCode);
    let add="";
    if(!isEmpty(json.user.building))
    {
        add+=json.user.building;
    }
    if(!isEmpty(json.user.address))
    {
        add+=" "+json.user.address;
    }
 
   localStorage.setItem("address", add)
   }
   else
    {
        localStorage.setItem("phoneNo", json.user.phoneNo)
        localStorage.setItem("empCode", json.user.empCode) 
        localStorage.setItem("empName", json.user.empName)
        localStorage.setItem("address", json.user.address)
    }
   localStorage.setItem("birthPlace", json.user.birthPlace)

  localStorage.setItem("userType", json.userType.toLowerCase())
  localStorage.setItem("userTypeOrg", json.userType)
  localStorage.setItem("userName", json.userName)


 window.location.href = "/Dashboard";

         

    }
    Forgot(){

        ReactDOM.render(<Forgot />, document.getElementById('c11'));
       }

    

    render() {


        return (

        <div className="index_bg">
        <div className="content-overlay" ></div> 
        <div className="header-navbar-shadow--"></div>
        <div className="content-wrapper">
            <div className="content-header row">
            </div>
            <div className="content-body">
                <div className="auth-wrapper auth-v1 px-2">
                    <div className="auth-inner py-2">
                       
                        <div className="card mb-0">
                            <div className="card-body">
                                <a href="javascript:void(0);" className="brand-logo">
                                    
                                            <img className="w-50"  src="../../../app-assets/images/pages/Weikfield-RGB-02.png" alt=""/>
                                </a>
                                <h3 className="ml-0 pl-4"><b>Partner Portal V2 Admin</b></h3>
                                <h5><center><b>v 1.1</b></center></h5>
                                <form className="auth-login-form mt-2" action="index.html" method="POST">
                                    <div className="form-group">
                                        <label   className="form-label">Login Id</label>
                                        <input type="text" className="form-control" id="login-id" name="login-id" placeholder="Login Id"  
                                        tabIndex="1" autoFocus 
                                        onKeyPress={e => {
                                            if(e.key === 'Enter'){
                                               this.submit()
                                            }
                                        }} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="login-password" className="form-label">Password</label>
                                        <input type="password" className="form-control" id="login-password" name="login-password" 
                                        placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" 
                                        aria-describedby="login-password" tabIndex="2"  autoFocus 
                                        onKeyPress={e => {
                                            if(e.key === 'Enter'){
                                               this.submit()
                                            }
                                        }} />
                                    </div>

                                   
                                    {/* <div className="form-group">
                                        <div className="custom-control custom-checkbox">
                                            <input className="custom-control-input" type="checkbox" id="remember-me" tabIndex="3" />
                                            <label className="custom-control-label" htmlFor="remember-me"> Remember Me </label>
                                        </div>
                                    </div> */}
                                    <button className="btn btn-primary btn-block" tabIndex="4" type="button" onClick={()=>this.submit()}>Sign in</button>
                                </form>

                                 <p className="text-center mt-2">
                                    
                                    <a    href="/ForgotPassword">
                                        <span>Forgot Password?</span>
                                    </a>
                                </p> 
                            </div>
                        </div>
                        
                    </div>
                </div>

            </div>
        </div>
    </div>
            


        );


    }
}
export default login
